import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    foundedImage = "foundedImage",
    locationImage = "locationImage",
    founded = "founded",
    foundedYear = "foundedYear",
    location = "location",
    locationAddress = "locationAddress"
}

interface Props extends WidgetProps {
    fields: {
        [fields.foundedImage]: string;
        [fields.locationImage]: string;
        [fields.founded]: string;
        [fields.foundedYear]: string;
        [fields.location]: string;
        [fields.locationAddress]: string;
    };
}
export interface TextFieldStyles {
    mainWrapper?: InjectableCss;
    textField?: InjectableCss;
    foundationIconWrapper?: InjectableCss;
    textIconWrapper?: InjectableCss;
    title?: InjectableCss;
    subTitle?: InjectableCss;
    icon?: InjectableCss;
}

const TextFieldStyles = {
    mainWrapper:{
        css: css`
            display: flex;
            flex-direction: row;
            gap: 10%;
        `
    },
    textField: {
        css: css`
        
        `
    },
    foundationIconWrapper:{
        css:css`
            display: flex;
            flex-direction: row;
            gap: 2px;
            align-items: center;
        }
        `
    },
    textIconWrapper:{
        css:css`
        display: flex;
        flex-direction: column;
        `
    },
    title: {
        css:css`    
            font-size: 1.2rem;
            color: #04569e;
            font-family: Barlow-Regular;
        `
    },
    subTitle:{
        css:css`
            font-family: Barlow-Bold;
            font-size: 1.6rem;
            color: #04569e;
            line-height: 28px;
        `
    },
    icon:{
        css:css`
            width: 65px;
            height: 65px;

        `
    }
};
 const styles = TextFieldStyles;
export const AboutUsFoundedIcon: React.FC<Props> = ({fields}) => {
    return (
        <GridContainer>
            <GridItem width={12} {...styles.mainWrapper}>
                <StyledWrapper {...styles.foundationIconWrapper}>
                  
                    <Img src={fields.foundedImage} alt="Founded Image" {...styles.icon} />
                    <StyledWrapper {...styles.textIconWrapper}>
                        <Typography {...styles.title} >
                            {fields.founded}
                        </Typography>
                        <Typography {...styles.subTitle} >
                            {fields.foundedYear}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.foundationIconWrapper}>
                   
                    <Img src={fields.locationImage} alt="Location Image" {...styles.icon} />
                    <StyledWrapper {...styles.textIconWrapper}>
                        <Typography {...styles.title}>
                            {fields.location}
                        </Typography>
                        <Typography  {...styles.subTitle}>
                            {fields.locationAddress}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </GridContainer>
        
    );
};

const widgetModule: WidgetModule = {
    component: AboutUsFoundedIcon,
    definition: {
        group: "Basic",
        icon: "text",
        displayName: "Text Field",
        fieldDefinitions: [
            {
                name: fields.foundedImage,
                displayName: "Founded Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Contextual"
            },
            {
                name: fields.founded,
                displayName: "Founded",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual"
            },
            {
                name: fields.foundedYear,
                displayName: "Founded Year",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual"
            },
            {
                name: fields.locationImage,
                displayName: "Location Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Contextual"
            },
            {
                name: fields.location,
                displayName: "Location",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual"
            },
            {
                name: fields.locationAddress,
                displayName: "Location Address",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual"
            },
        ],
    },
};

export default widgetModule;

